import Card from "@erecht24/frontend-kit/theme/components/cards/Card";
import CardBody from "@erecht24/frontend-kit/theme/components/cards/CardBody";
import {StateContext} from "../Contexts";
import {useContext, useRef} from "react";
import ValidationToolTip from "./ValidationToolTip";
import {track} from "../Util/tracking";

export default function () {
    /** @type CheckoutState */
    const state = useContext(StateContext);
    const allowCancellationCheckboxRef = useRef(null);

    const updateState = () => {
        let cancellationAllowed = allowCancellationCheckboxRef.current.checked;
        let validation = [];

        if (state.paymentProviderChangeModeEnabled && !cancellationAllowed) {
            validation.push('allowCancellation');
        }

        state.setAllowCancellationValidation(validation);
        state.setAllowCancellation(cancellationAllowed);

        track(
            null,
            'checkout',
            'migration',
            'checkbox',
            cancellationAllowed ? 'checked' : 'unchecked'
        )
    };

    return <Card>
        <CardBody>
            <h3 className="h3 text-center lg:text-left text-balance lg:text-wrap mb-6">Kündigung Ihres alten Tarifs</h3>
            <label className="relative flex flex-row items-center gap-6">
                <input
                    className="scale-[200%]"
                    type="checkbox"
                    ref={allowCancellationCheckboxRef}
                    onChange={updateState}
                    checked={state.allowCancellation}
                />
                <span>
                    Ich erteile eRecht24 die Vollmacht zur Kündigung meiner bestehenden Mitgliedschaft bei der Digistore24 GmbH.
                </span>
                {state.allowCancellationValidation.includes('allowCancellation') &&
                    <ValidationToolTip>Sie müssen die Vollmacht zur Kündigung erteilen, um den Vorgang abzuschließen.</ValidationToolTip>
                }
            </label>
        </CardBody>
    </Card>
}
